import React, { useState } from "react";
import PropTypes from "prop-types";
import { Map, StandardPinSize } from "components/Shared";
import { getCasePinURL } from "components/Shared/Map";

const TabMap = (props) => {
  const [infoBoxCoords, setInfoBoxCoords] = useState(null);
  const [showInfoBox, setShowInfoBox] = useState(false);

  const onShowCoords = (e) => {
    setInfoBoxCoords({ lat: parseFloat(e.latLng.lat().toFixed(7)), lng: parseFloat(e.latLng.lng().toFixed(7)) });
    setShowInfoBox(true);
  };

  const onHideCoords = () => {
    setShowInfoBox(false);
    setInfoBoxCoords(null);
  };

  const infoBoxOptions = { closeBoxURL: "", enableEventPropagation: true, style: { overflow: "none" } };

  const getPins = () => {
    let pins = [{ id: "pin0", latitude: props.lat, longitude: props.lng, icon: { url: getCasePinURL("red", false, false), ...StandardPinSize } }];
    if (infoBoxCoords) {
      pins.push({ id: "pin1", latitude: infoBoxCoords.lat, longitude: infoBoxCoords.lng, icon: { url: getCasePinURL("red", false, false), ...StandardPinSize } });
    }
    return pins;
  };

  const getInfoBox = () => {
    if (!showInfoBox) return null;

    return {
      infoBoxCoords: infoBoxCoords,
      infoBoxOptions: infoBoxOptions,
      infoBoxChildren: (
        <>
          <div>Latitude: {infoBoxCoords.lat}</div>
          <div>Longitude: {infoBoxCoords.lng}</div>
        </>
      ),
    };
  };

  return (
    <Map
      containerClass="map-control"
      loadingClass="map-control"
      mapClass="map-control"
      mapType="satellite"
      onMapClick={onShowCoords}
      onMapRightClick={onHideCoords}
      pins={getPins()}
      showInfoBox={showInfoBox}
      infoBoxProps={getInfoBox()}
      zoom={20}
      center={{ lat: props.lat, lng: props.lng }}
    />
  );
};

TabMap.propTypes = {
  lat: PropTypes.number,
  lng: PropTypes.number,
};

export default TabMap;